"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IgnoreAppRightMargins = exports.IgnoreAppMargins = exports.ApplyAppMargins = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var appMargins_1 = __importDefault(require("./appMargins"));
var useStyles = core_1.makeStyles(function () {
    return core_1.createStyles({
        applyAppMarginsContainer: {
            marginLeft: function (props) { return props.appMargins; },
            marginRight: function (props) { return props.appMargins; },
        },
        ignoreAppMarginsContainer: {
            marginLeft: function (props) { return -props.appMargins; },
            marginRight: function (props) { return -props.appMargins; },
        },
        ignoreAppRightMarginsContainer: {
            marginLeft: 0,
            marginRight: function (props) { return -props.appMargins; },
        },
        layout: {
            flexGrow: 1,
        },
    });
});
var ApplyAppMargins = function (_a) {
    var className = _a.className, children = _a.children;
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    return (react_1.default.createElement("div", { className: classnames_1.default(className, classes.applyAppMarginsContainer) }, children));
};
exports.ApplyAppMargins = ApplyAppMargins;
var IgnoreAppMargins = function (_a) {
    var className = _a.className, children = _a.children;
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    return (react_1.default.createElement("div", { className: classnames_1.default(className, classes.ignoreAppMarginsContainer) }, children));
};
exports.IgnoreAppMargins = IgnoreAppMargins;
var IgnoreAppRightMargins = function (_a) {
    var className = _a.className, children = _a.children;
    var appMargins = appMargins_1.default();
    var classes = useStyles({ appMargins: appMargins });
    return (react_1.default.createElement("div", { className: classnames_1.default(className, classes.ignoreAppRightMarginsContainer) }, children));
};
exports.IgnoreAppRightMargins = IgnoreAppRightMargins;
